module.exports = __webpack_public_path__ + "assets/android-icon-192x192.c422c68b.png";